<template>
	<div class="step_list">
		<div class="divide_list"></div>
		<div class="step_item" v-for="item in list" :key="item.id" :class="{ active: curId == item.id }">
			<div class="value">
				<div class="value_label">{{ item.label }}</div>
				<div class="value_content" v-html="item.content"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'StepList',
		props: {
			curId: {
				type: [String, Number],
				default: ''
			},
			list: {
				type: Array,
				default: () => ([])
			}
		}
	};
</script>

<style scoped lang="less">
	.step_list {
		position: relative;
		.divide_list {
			position: absolute;
			top: 0;
			left: 20px;
			width: 1px;
			height: 100%;
			background-image: linear-gradient(to bottom, transparent 0%, transparent 50%, #BBBFC4 50%, #BBBFC4 100%);
			background-size: 1px 20px;
			background-repeat: repeat-y;
		}
		.step_item {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			position: relative;
			&+.step_item { margin-top: 54px; }
			&:after {
				content: '';
				position: absolute;
				left: 9px;
				top: 2px;
				width: 24px;
				height: 24px;
				background-color: #BBBFC4;
				transform: rotateZ(45deg);
			}
			.value {
				flex: auto;
				padding-left: 60px;
				font-family: PingFangSC-Regular;
				font-size: 24px;
				font-weight: normal;
				line-height: 29px;
				color: #8F959E;
				.value_label { margin-bottom: 4px; }
			}
			&.active {
				.title { color: @primary; }
				.value { color: #2B2F36; }
			}
		}
	}
</style>
